import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { formatChatbotAnswer } from './format-chatbot-answer';

@Pipe({
  name: 'chatbotAnswer',
  standalone: false
})
export class ChatbotAnswerPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(formatChatbotAnswer(value || ''));
  }
}
